// Deploy-driven auto-reload feature.
//
// The backend pushes its running version to a socket the moment that socket
// subscribes to APP_VERSION_TOPIC. Because the frontend re-subscribes on every
// reconnect (see useWS.ts), this fires both on initial page load and again
// after a deploy restarts the backend and clients reconnect. The frontend
// compares the received version against the one it booted with and, on a
// mismatch, prompts the user to save and reload — see useAppVersion.ts and
// ws.gateway.ts.
export const APP_VERSION_TOPIC = 'app:version'
export const APP_VERSION_MESSAGE_TYPE = 'app:version'

export type AppVersionPayload = {
  version: string
}
